/**
 * Maps a METHOD graft model node to MethodData: type, name, parameters (name + type), and returns (formatted return type).
 * METHOD payload: [NAME, TYPE_USAGE (return), MODIFIER, PARAMETERS_ARRAY]
 */

import type { Method, MethodData, Parameter } from '@/core/types/library.type'

import { VOID_TYPE_USAGE_FALLBACK } from '../../const/typeUsageFallback.const'
import { getUnifiedGraftModelType } from '../getUnifiedGraftModelType'

import { formatTypeUsage, getIsNullableFromTypeUsage, getPrimitiveTypeFromTypeUsage } from './formatTypeUsage'
import { parseParameterPayload } from './parseParameterPayload'
import { safeString } from './safeString'

export const mapMethod = (item: Method): MethodData => {
  const [name, returnType, , parametersArray] = item.payload
  const parameters = parametersArray?.payload ?? []
  const returnTypeForFormat = returnType ?? VOID_TYPE_USAGE_FALLBACK

  return {
    type: getUnifiedGraftModelType(item) as MethodData['type'],
    name: safeString(name),
    parameters: parameters.map((param: Parameter) => {
      const { typeUsage, name: paramName } = parseParameterPayload(param)
      const isNullable = getIsNullableFromTypeUsage(typeUsage)

      return {
        name: paramName,
        type: formatTypeUsage(typeUsage),
        isNullable,
        isNullabel: isNullable,
        primitiveType: getPrimitiveTypeFromTypeUsage(typeUsage),
        typeUsage,
      }
    }),
    returns: formatTypeUsage(returnTypeForFormat),
    returnTypeUsage: returnType,
  }
}
